export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 1_12.eccc1962.jpg";